export default () => ({
    isAuthenticated: false,
    user: null,
    idToken: null,
    refreshToken: null,
    userRole: null,
    userId: null
})